import {
	Button,
	InputAdornment, TextField,
	Typography,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import React, { useState } from "react";
import { useBuilder } from "../../useBuilder";

export function AssistantGetStarted(props: {
	onSubmit: (assetId: string, topics: string, scriptureReferences: string) => void;
}) {
	const { onSubmit } = props;
	const builder = useBuilder();

	const [topics, setTopics] = useState("");
	const [topicError, setTopicError] = useState<string>();
	const [scriptureReferences, setScriptureReferences] = useState("");
	const [scriptureError, setScriptureError] = useState<string>();

	const submit = () => {
		if (topics.length === 0) {
			setTopicError("You must enter at least one topic");
			return;
		}
		else {
			setTopicError(undefined);
		}

		if (scriptureReferences.length === 0) {
			setScriptureError("You must enter at least one scripture");
			return;
		} else {
			setScriptureError(undefined);
		}

		onSubmit(builder.builderAsset.id, topics, scriptureReferences);
	};

	return (
		<>
			<Typography
				color="textPrimary"
				style={{ margin: 12, paddingBottom: 10 }}
			>
				Need help getting started? Enter a Topic and Scripture to get fresh ideas and a preaching plan.
			</Typography>

			<TextField
				id="topic"
				variant="outlined"
				placeholder="Enter a Topic (ex: Faith)"
				value={topics}
				onChange={(e) => setTopics(e.target.value)}
				error={topicError !== undefined}
				helperText={topicError}
				style={{ width: "100%" }}
				InputProps={{
					style: {
						backgroundColor: "white",
						marginTop: 5,
						marginBottom: 5,
					},
					startAdornment: (
						<InputAdornment position="start">
							<SearchIcon />
						</InputAdornment>
					),
				}}
			/>

			<TextField
				id="scripture"
				variant="outlined"
				placeholder="Enter a Scripture (ex: John 17:1)"
				value={scriptureReferences}
				onChange={(e) => setScriptureReferences(e.target.value)}
				error={scriptureError !== undefined}
				helperText={scriptureError}
				style={{ width: "100%" }}
				InputProps={{
					style: {
						backgroundColor: "white",
						marginTop: 5,
						marginBottom: 5,
					},
					startAdornment: (
						<InputAdornment position="start">
							<SearchIcon />
						</InputAdornment>
					),
				}} 
			/>

			<Button
				onClick={submit}
				variant="contained"
				color="primary"
				style={{ marginTop: 10, marginBottom: 15 }}
			>
				Get ideas for your sermon
			</Button>
		</>
	);
}
